import { usePage } from '@inertiajs/react'
import Stage from './Stage'
import { Fragment } from 'react'

export default function Card() {
  const { transaction } = usePage().props

  return (
    <div className="space-y-4 border-b border-gray-200 bg-white px-2 pb-4 pt-2">
      <div className="flex flex-wrap justify-center gap-1.5">
        {Boolean(transaction.paused_at) && (
          <span className="inline-block whitespace-nowrap rounded bg-red-600 px-2.5 py-1.5 text-sm font-medium uppercase leading-none text-white">
            <span>Paused</span>
          </span>
        )}

        {transaction.status === 'Pending' && (
          <span className="inline-block whitespace-nowrap rounded bg-blue-500 px-2.5 py-1.5 text-sm leading-none text-white">
            <span>Sale Pending</span>
          </span>
        )}

        {['Archived', 'Lost'].indexOf(transaction.status) >= 0 && (
          <span className="inline-block whitespace-nowrap rounded bg-red-600 px-2.5 py-1.5 text-sm leading-none text-white">
            <span>{transaction.status}</span>
          </span>
        )}

        {['On-Hold'].indexOf(transaction.status) >= 0 && (
          <span className="inline-block whitespace-nowrap rounded bg-yellow-200/80 px-2.5 py-1.5 text-sm font-medium leading-none text-yellow-600">
            <span>{transaction.status}</span>
          </span>
        )}

        {['Compliance', 'Under Review'].indexOf(transaction.status) >= 0 && (
          <span className="inline-block whitespace-nowrap rounded bg-orange-200/60 px-2.5 py-1.5 text-sm font-medium leading-none text-orange-600">
            <span>{transaction.status}</span>
          </span>
        )}

        {['Closed'].indexOf(transaction.status) >= 0 && (
          <span className="inline-block whitespace-nowrap rounded bg-orange-500 px-2.5 py-1.5 text-sm font-medium uppercase leading-none text-white">
            <span>Closed</span>
          </span>
        )}

        {transaction.completed_at && (
          <span className="inline-block whitespace-nowrap rounded bg-green-600 px-2.5 py-1.5 text-sm font-medium uppercase leading-none text-white">
            <span>Completed</span>
          </span>
        )}

        {!Boolean(transaction.paused_at) && (
          <Fragment>
            {transaction.property_type ? (
              <span className="inline-block whitespace-nowrap rounded bg-gray-200 px-2.5 py-1.5 text-sm leading-none text-gray-800">
                <span>{transaction.property_type}</span>
              </span>
            ) : (
              transaction.propertyTypes?.length > 0 &&
              transaction.propertyTypes.map((type) => (
                <span
                  className="inline-block whitespace-nowrap rounded bg-gray-200 px-2.5 py-1.5 text-sm leading-none text-gray-800"
                  key={type.id}
                >
                  <span>{type.name}</span>
                </span>
              ))
            )}

            {transaction.property_state ? (
              <span className="inline-block whitespace-nowrap rounded bg-gray-200 px-2.5 py-1.5 text-sm leading-none text-gray-800">
                <span>{transaction.property_state}</span>
              </span>
            ) : (
              transaction.states?.length > 0 &&
              transaction.states.map((state) => (
                <span
                  className="inline-block whitespace-nowrap rounded bg-gray-200 px-2.5 py-1.5 text-sm leading-none text-gray-800"
                  key={state.id}
                >
                  <span>{state.state}</span>
                </span>
              ))
            )}
          </Fragment>
        )}
      </div>

      {!transaction.completed_at && !transaction.paused_at && <Stage className="mx-auto max-w-lg px-4" transaction={transaction} />}
    </div>
  )
}
